import { Avatar, Button, Divider, Stack, Typography } from '@mui/material';
import { CustomDivider } from '../Utils/CustomDivider';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import {
  AppointmentOrder,
  BigButton,
  CompassRights,
  OrderMedications,
  Statoscope,
  SubmitApplication,
} from 'Images';
import { useNavigate } from 'react-router-dom';
import { Fragment } from 'react';
import { Payments } from 'Images/ActivitiesLobby';

const actionsByType: {
  [type: number]: {
    label: string;
    icon: string;
    url: string;
    isExternal?: boolean;
  };
} = {
  1: {
    label: 'הגשת פנייה לאגף',
    icon: SubmitApplication,
    url: '/universalRequest',
  },
  2: {
    label: 'זימון תור',
    icon: AppointmentOrder,
    url: 'https://myvisit.com/#%21/home/provider/231',
    isExternal: true,
  },
  3: {
    label: 'מצפן הזכויות',
    icon: CompassRights,
    url: '/compass-rights',
  },
  4: {
    label: 'הזמנת תרופות',
    icon: OrderMedications,
    url: '/medicine',
  },
  5: {
    label: 'הפניות רפואיות',
    icon: Statoscope,
    url: '/medical-referrals',
  },
  6: {
    label: 'פירוט תשלומים וניכויים',
    icon: Payments,
    url: '/payments&deductions',
  },
};

const mockListData: number[] = [1, 2, 3, 4, 5, 6];

export const CommonActions = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).commonActions;
  const navigate = useNavigate();

  return (
    <Stack>
      {isDesktop && (
        <>
          <Typography variant='h5'>{dictionary.title}</Typography>
          <CustomDivider />
        </>
      )}
      <Stack
        bgcolor={'white'}
        p={isDesktop ? '0 24px 32px' : '0 0 24px'}
        gap={'16px'}
        alignItems={'center'}
        borderRadius={'16px'}
        border={'1px solid'}
        borderColor={isDesktop ? 'primary.shade_100' : 'primary.shade_200'}
        mt={'16px'}
        maxWidth={'1212px'}
        boxShadow={'0px 2px 20px 0px rgba(58, 110, 236, 0.12)'}
      >
        <Stack
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={isDesktop ? 'space-around' : 'center'}
          gap={isDesktop ? '14px' : '0px 6px'}
          display={isDesktop ? undefined : 'grid'}
          gridTemplateColumns={isDesktop ? undefined : '1fr 1px 1fr 1px 1fr'}
        >
          {mockListData.map((type, index) => (
            <Fragment key={type}>
              <Button
                sx={{
                  m: isDesktop ? '24px 0' : '24px auto',
                  p: 0,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  width: isDesktop ? '182px' : '100px',
                  height: isDesktop ? '118px' : undefined,
                  '&:hover': {
                    bgcolor: '#E4C1FF',
                  },
                }}
                onClick={() => {
                  if (actionsByType[type].isExternal)
                    window.open(actionsByType[type].url);
                  else navigate(actionsByType[type].url);
                }}
              >
                <Avatar
                  sx={isDesktop ? undefined : { width: '32px', height: '32px' }}
                  src={actionsByType[type].icon}
                  alt=''
                />
                <Typography color={'initial'} variant='body5'>
                  {actionsByType[type].label}
                </Typography>
              </Button>
              {index < mockListData.length - 1 &&
                (isDesktop ? true : index !== 2) && (
                  <Divider
                    orientation='vertical'
                    flexItem
                    aria-hidden='true'
                    sx={{
                      borderColor: 'primary.shade_200',
                      m: '24px 0',
                    }}
                  />
                )}
            </Fragment>
          ))}
        </Stack>
        <Button
          onClick={() => navigate(dictionary.actionsLobbyUrl)}
          sx={{ p: 0, width: 'fit-content' }}
          endIcon={
            <Avatar
              sx={{ height: '50px', width: '46px', mt: '6px' }}
              src={BigButton}
              alt=''
            />
          }
        >
          <Typography variant='body5'>{dictionary.buttonText}</Typography>
        </Button>
      </Stack>
    </Stack>
  );
};
